import Module from './Module';

const module = new Module('cards', '/api/v1/cards', true);

export const {
  get, getById, save, remove, resetState, resetSuccessSave,
} = module;

export default module.reducer;



// WEBPACK FOOTER //
// ./src/modules/cards.js